<template>
  <main />
</template>

<script>


export default {

  components: {
   
  },

  data() {
    return {

    };
  },

  computed: {

  },

  mounted(){
   
  },

  methods: {
   
  },
};
</script>

<style></style>
